import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { HexaAppCustomDop } from './models/CustomDopModels';

export class ApiAppCustomDop extends ApiHexaBase {
  public static appCustomDopBaseUrl(
    id: string | number,
    application_id: string | number
  ): string {
    return `${ApiHexaBase.baseUrl}/customers/${id}/applications/${application_id}/custom_dop`;
  }

  public static async index(
    id: string | number,
    application_id: string | number,
    params: {
      page?: number;
      size?: number;
      exclude?: boolean;
    }
  ) {
    const response = await ApiBase.get(
      this.appCustomDopBaseUrl(id, application_id),
      params
    );

    return response.data.data as {
      total: number;
      custom_dop: HexaAppCustomDop[];
    };
  }

  public static async create(
    id: string | number,
    application_id: string | number,
    selected_dop_ids: number[]
  ) {
    const response = await ApiBase.post(
      this.appCustomDopBaseUrl(id, application_id),
      {
        custom_dop_ids: selected_dop_ids,
      }
    );
    return response;
  }

  public static async destroy(
    id: string | number,
    application_id: string | number,
    custom_dop_id: string | number
  ) {
    const response = await ApiBase.delete(
      `${this.appCustomDopBaseUrl(id, application_id)}/${custom_dop_id}`
    );
    return response;
  }
}
